import { Text } from '#atoms';

import DegreeIcon from '#assets/svg/graduation-cap.svg';
import AwardIcon from '#assets/svg/awards_icon.svg';
import Certificate from '#assets/svg/certification_icon.svg';

import {
  LabelBox,
  QualificationBox,
  QualificationContainer,
  QualificationItem
} from '#templates/CoachDetailContent/DetailInfo/CoachIntroduce/styles';

import { useQuery } from '@tanstack/react-query';
import { axios } from '#api/axios';

type QualificationsResponse = {
  degree: { major: string }[];
  licenses: { name: string }[];
  awards: number;
};

const Qualifications = () => {
  const { data } = useQuery({
    queryKey: ['qualifications'],
    queryFn: async () =>
      await axios.get<QualificationsResponse>('accounts/coach/qualification'),
    select: ({ data }) => data
  });

  if (!data) return null;

  const isVisible =
    data.degree.length > 0 || data.licenses.length > 0 || data.awards > 0;

  return isVisible ? (
    <QualificationContainer>
      <LabelBox>
        <Text textStyle="t3">검증된 자격사항</Text>
      </LabelBox>
      <QualificationBox>
        {data
          ? data.degree.map((value, index) => {
              return (
                <QualificationItem key={index}>
                  <img src={DegreeIcon} alt="icon" />
                  <Text style={{ fontSize: '1.2rem' }}>{value.major}</Text>
                </QualificationItem>
              );
            })
          : null}
        {data
          ? data.licenses.map((value, index) => {
              return (
                <QualificationItem key={index}>
                  <img src={Certificate} alt="icon" />
                  <Text style={{ fontSize: '1.2rem' }}>{value.name}</Text>
                </QualificationItem>
              );
            })
          : null}
        {data && data.awards ? (
          <QualificationItem>
            <img src={AwardIcon} alt="icon" />
            <Text style={{ fontSize: '1.2rem' }}>수상경력 {data.awards}회</Text>
          </QualificationItem>
        ) : null}
      </QualificationBox>
    </QualificationContainer>
  ) : (
    <></>
  );
};

export default Qualifications;
